import commonMessages from "./commonMessages";
import { regex } from "./regexValidation";
import { toastMessage } from "./toastMessage";

const {
  imageFileRegex,
  documentFileRegex,
  audioFileRegex,
  videoFileRegex,
  pdfFileRegex,
} = regex;
const {
  IMAGE_FORMAT,
  VIDEO_FORMAT,
  DOC_FORMAT,
  VALID_AUDIO,
  PDF_FORMAT,
} = commonMessages;

const fileRegexHandler = (mediaType) => {
  const regexMap = {
    image: { regexValidator: imageFileRegex, error: IMAGE_FORMAT },
    document: { regexValidator: documentFileRegex, error: DOC_FORMAT },
    audio: { regexValidator: audioFileRegex, error: VALID_AUDIO },
    video: { regexValidator: videoFileRegex, error: VIDEO_FORMAT },
    pdf: { regexValidator: pdfFileRegex, error: PDF_FORMAT },
  };

  return (
    regexMap[mediaType] || {
      regexValidator: null,
      error: "Invalid Format File",
    }
  );
};

export const imageHandler = async (
  e,
  setFile,
  mediaType = "image",
  apiCall = null
) => {
  e.preventDefault();
  const { regexValidator, error } = fileRegexHandler(mediaType);

  const file = e.target.files[0];

  //   console.log(file,"file")

  const resetFile = () => {
    e.target.value = "";
    setFile("");
  };

  if (!file) {
    resetFile();
    return;
  }

  if (regexValidator && regexValidator.test(file.name)) {
    setFile(file);
    if (apiCall) {
      apiCall(file);
    }
  } else {
    resetFile();
    toastMessage(error, "error", "imageFormat");
  }
};

// Uploading Multiple Images In Array
export const multipleImageHandler = async (
  e,
  setFiles,
  mediaType = "image",
  apiCall = null
) => {
  e.preventDefault();

  const { regexValidator, error } = fileRegexHandler(mediaType);
  const files = Array.from(e.target.files); // Convert FileList to an array

  if (!files.length) {
    return;
  }

  const validFiles = [];
  const invalidFiles = [];

  files.forEach((file) => {
    if (regexValidator && regexValidator.test(file.name)) {
      const fileObject = {
        _id: Date.now() + Math.round(Math.random() * 1000), // Use current timestamp as unique ID
        file,
      };
      validFiles.push(fileObject);
      if (apiCall) {
        apiCall(file); // Call API for each valid file
      }
    } else {
      invalidFiles.push(file);
    }
  });
  // Append valid files to the existing array without resetting
  if (validFiles.length) {
    setFiles((prevFiles) => [...prevFiles, ...validFiles]);
  }

  // Display error messages for invalid files
  if (invalidFiles.length) {
    toastMessage(
      `Invalid files: ${invalidFiles.map((f) => f.name).join(", ")}`,
      "error",
      "imageFormat"
    );
  }
};
